import { render, staticRenderFns } from "./candidateList.vue?vue&type=template&id=2115e208&scoped=true&"
import script from "./candidateList.vue?vue&type=script&lang=js&"
export * from "./candidateList.vue?vue&type=script&lang=js&"
import style0 from "./candidateList.vue?vue&type=style&index=0&id=2115e208&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115e208",
  null
  
)

export default component.exports